export const FAQ_LINK_HOST = 'https://www.ekoz.ai/host-faqs';
export const FAQ_LINK_ADVERTISER = 'https://www.ekoz.ai/advertiser-faqs';
export const TERMS_OF_SERVICE_LINK = 'https://www.ekoz.ai/terms-of-service';

export const SIGN_UP_GUIDE_ADVERTISER_LINK = 'https://www.ekoz.ai/advertiser-sign-up-guide';
export const SIGN_UP_GUIDE_HOST_LINK = 'https://www.ekoz.ai/host-sign-up-guide';
